export const MAX_FREE_EDITORS = 2;
